import { ModalConfirm } from '@/components/element/modal/ModalConfirm';
import { FixedAssetRow } from '@/components/features/tasks/payment/[payment_task_id]/PaymentTaskFixedAssetEditForm/PaymentTaskFixedAssetsElement/FixedAssetRow';
import { NonFixedAssetRow } from '@/components/features/tasks/payment/[payment_task_id]/PaymentTaskFixedAssetEditForm/PaymentTaskFixedAssetsElement/NonFixedAssetRow';
import { usePaymentTaskFixedAssetsInvalidate } from '@/hooks/api/1150_payment_task_fixed_assets';
import { useDestroyPaymentTaskFixedAsset } from '@/hooks/api/1180_destroy_payment_task_fixed_asset';
import { PaymentTaskFixedAsset } from '@/hooks/api/models';
import { useLoading } from '@/providers/LoadingProvider';
import { useCurrentPaymentTask } from '@/providers/PaymentTaskProvider';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

export const PaymentTaskFixedAssetsElement = ({ paymentTaskFixedAssets }: { paymentTaskFixedAssets: PaymentTaskFixedAsset[] }) => {
  const { setShowLoading } = useLoading();
  const { _w_, _t_, me } = useCurrentTeamMember();
  const { purchase_order_id } = useParams();
  const { paymentTask: task } = useCurrentPaymentTask();
  const [delTarget, setDelTarget] = useState<PaymentTaskFixedAsset>();
  const { mutate: destroyMutate, isSuccess: destroyIsSuccess, isPending: destroyIsPending } = useDestroyPaymentTaskFixedAsset();
  const { invalidate } = usePaymentTaskFixedAssetsInvalidate({
    identifier: _w_!.identifier,
    team_id: _t_!.id,
    purchase_order_id: Number(purchase_order_id),
    task_id: task!.id,
  });

  useEffect(() => {
    if (destroyIsSuccess) {
      invalidate();
    }
  }, [destroyIsSuccess]);

  useEffect(() => setShowLoading(destroyIsPending), [destroyIsPending]);

  const onDeleteClick = () => {
    setShowLoading(true);
    destroyMutate({
      identifier: _w_!.identifier,
      team_id: _t_!.id,
      purchase_order_id: Number(purchase_order_id),
      task_id: task!.id,
      id: delTarget!.id,
    });
  };

  return (
    <div className="table-responsive">
      <ModalConfirm modalId={`delConfirm`} okClicked={() => onDeleteClick()} message={'削除します。よろしいですか？'} />

      <table className="table align-items-center">
        <thead>
          <tr>
            <th className="text-secondary text-xxs font-weight-bolder opacity-7 px-2">資産分類</th>
            <th className="text-secondary text-xxs font-weight-bold opacity-7 px-2 text-end" style={{ width: 150 }}>
              金額
            </th>
            <th className="text-secondary text-xxs font-weight-bold opacity-7 px-2" style={{ width: 100 }}></th>
          </tr>
        </thead>
        <tbody>
          <NonFixedAssetRow />

          {paymentTaskFixedAssets.map((d) => (
            <FixedAssetRow key={`ptfa-${d.id}`} d={d} setDelTarget={setDelTarget} />
          ))}
        </tbody>
      </table>
    </div>
  );
};
